import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';


import { BaseWebService } from "../shared/services/base-web.service";
import 'rxjs/add/observable/throw';
import { config } from "../../../config";

@Injectable()
export class TreatmentApprovalService {

    constructor(
        private _basewebservice: BaseWebService
    ) { }

    getTreatmentApprovalList = (searchKey: any, limit: any, offset: any, location: any, sortParam: any, order: any, approvalId: any) => {
        let query = "v1/treatment_approval/?limit=" + limit + "&offset=" + offset;
        if (searchKey) {
            query = query + "&search=" + searchKey;
        }
        if (location) {
            query = query + "&location_id=" + location;
        }
        if (sortParam) {
            query = query + "&sort=" + sortParam + "&order=" + order;
        }
        if (approvalId) {
            query = query + "&plan_id=" + approvalId;
        }
        return this._basewebservice.request(query, "get")
            .map(res => res)
            .catch(this.handleError);
    }

    approveTreatment = (id: any) => {
        let reqData: any = {};
        let data: any = {};
        data.docusign_redirect_url = location.origin + config.publicPath + "/docusign-approval-complete/" + id + "/" ;
        reqData.body = data;
        reqData.id = id;
        return this._basewebservice.request("v1/treatment_approval/" + id + "/", "put", reqData)
            .map(res => res)
            .catch(this.handleError);
    }

    /**
     * Function for handling service call errors
     * @param  {Response|any} error contains error data
     */

    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}
